import { ApolloError } from "@apollo/client";
interface BasePagination {
  page: number;
  perPage: number;
}
type ForwardPagination = BasePagination & {
  startCursor?: undefined;
  endCursor?: string;
};

type BackwardPagination = BasePagination & {
  startCursor?: string;
  endCursor?: undefined;
};

export type PaginationState = ForwardPagination | BackwardPagination;

export interface PaginationVariables {
  first?: number;
  after?: string;
  last?: number;
  before?: string;
}

export interface PaginatedResults<T> {
  items: T[];
  endCursor?: string;
  startCursor?: string;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  totalCount: number | null;
  loading: boolean;
  error: ApolloError | undefined;
}

export const newState = (perPage = 1): PaginationState => ({
  page: 1,
  perPage,
});

export const getPaginationVars = (
  state: PaginationState,
): PaginationVariables => {
  const before = state.startCursor;
  const after = state.endCursor;
  const perPage = state.perPage;
  return {
    after,
    before,
    last: before ? perPage : undefined,
    first: before ? undefined : perPage,
  };
};

export const paginate = (
  newPage: number,
  prev: PaginationState,
  lastStartCursor: string | undefined,
  lastEndCursor: string | undefined,
): PaginationState => {
  if (newPage === prev.page) return prev;
  const state: PaginationState = {
    page: newPage,
    perPage: prev.perPage,
  };
  if (newPage > prev.page) {
    state.endCursor = lastEndCursor;
  } else {
    state.startCursor = lastStartCursor;
  }
  return state;
};
